<template>
  <v-dialog
    v-model="isVisible"
    persistent
    content-class="notification-wrp"
    max-width="450"
  >
    <div class="loader">
      <img
        style="width: 80px"
        v-if="type && getImageSrc"
        :src="getImageSrc"
        alt=""
      />
      <div class="title mt-5" v-if="title">
        {{ title }}
      </div>
      <div class="text mt-5" v-if="text">
        {{ text }}
      </div>
      <template v-else>
        <div class="text mt-4" v-if="type === 'error'">
          {{ $t("notifications.default_error") }}
        </div>
      </template>
    </div>
  </v-dialog>
</template>

<script>
export default {
  data: () => {
    return {
      isVisible: false,
      type: "",
      timeoutId: null,
      text: "",
      title: "",
    };
  },
  watch: {
    isVisible(newValue) {
      if (!newValue) {
        clearTimeout(this.timeoutId);
        this.timeoutId = null;
        document.documentElement.style.overflow = "auto";
      }
    },
  },
  computed: {
    getImageSrc() {
      return require(`@/assets/loader/${this.type}.png`);
    },
  },
  created() {
    window.getApp.$on(
      "NOTIFICATION_VISIBILITY",
      (show, type, text, time, title) => {
        this.type = show ? type : "";
        this.text = text ? text : "";
        this.title = title ? title : "";
        this.isVisible = show;

        document.documentElement.style.overflow = show ? "hidden" : "auto";
        this.timeoutId = setTimeout(
          () => {
            this.isVisible = false;
          },
          time ? time : 3000
        );
      }
    );
  },
};
</script>

<style lang="scss">
.notification-wrp {
  .loader {
    display: flex;
    align-items: center;
    flex-direction: column;
    background: #2e1826;
    border-radius: 8px;
    padding: 16px 24px;
    width: 100%;
    background-image: url("@/assets/modal-bg.png");
    background-size: cover;
    background-position: top;
    min-height: 300px;
    display: flex;
    align-items: center;
    justify-content: center;
    .text {
      text-align: center;
    }
    .title {
      font-family: "KyivType Sans" !important;
      font-size: 24px !important;
      font-style: normal;
      font-weight: 900;
      line-height: 32px;
      text-align: center;
    }
  }
}
</style>
